import { createLogger } from 'utility/datadog-util';
import { redactString } from 'common/utils/redaction';
export const PATIENT_TRANSFER_LOGGER_NAME = 'patientTransfer';
/**
 * Instantiate a logger relate to patient transfer and enrich with details about
 * which institution and which user is being transferred.
 *
 * Note, createLogger can return undefined if DataDog is not enabled
 */
export function createPatientTransferLogger(stateWatcher) {
    const institution = stateWatcher.getInstitutionInfo();
    const userInfo = stateWatcher.getUserInfo();
    const context = {
        clinic_id: institution.clinicId,
        clinic_domain: institution.domain,
        user_role: userInfo.userType,
        user_id: userInfo.userId,
        user_plan: userInfo.planType,
    };
    const logger = createLogger(PATIENT_TRANSFER_LOGGER_NAME, {
        context,
        level: 'info',
    });
    console.debug(`[${PATIENT_TRANSFER_LOGGER_NAME}]: Created logger`);
    return logger;
}
/**
 * Format the patient transfer context, this is done to schema the
 * information we need to capture the context of a patient transfer.
 *
 * The snake-casing follows the conventions set by the intelligence team
 * see https://doxyme.atlassian.net/wiki/spaces/BKT/pages/3640721750/How+to+guide+for+Segment+Event+Tracking
 */
export function formatPatientTransferContext({ transferId, person, eventSpan, institutionId, institutionName, originalRoomId, originalRoomName, originalRoomType, destinationRoomId, destinationRoomType, transferredFrom, }) {
    return {
        transfer_id: transferId,
        event_span: eventSpan,
        patient_username: redactString(person.state.username),
        clinic_id: institutionId,
        clinic_name: institutionName,
        original_room_name: originalRoomName,
        room_id: originalRoomId,
        original_room_id: originalRoomId,
        original_room_type: originalRoomType,
        destination_room_id: destinationRoomId,
        destination_room_type: destinationRoomType,
        transferred_from: transferredFrom,
    };
}
